//default
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgChartsModule} from 'ng2-charts';
import { GoogleChartsModule } from 'angular-google-charts';
import { DatePipe } from '@angular/common'
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
//comps
import { UserComponent } from './user/user.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { AuthGuard } from './auth/auth.guard';
import { LandComponent } from './land/land.component';
import { PwdChangeComponent } from './user/pwd-change/pwd-change.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { ForgotpwdComponent } from './user/forgotpwd/forgotpwd.component';
import { ResetPwdComponent } from './user/reset-pwd/reset-pwd.component';
import { RaiseTicketComponent } from './raise-ticket/raise-ticket.component';
import { AssignExpertComponent } from './moderator/assign-expert/assign-expert.component';
import { GetTicketsComponent } from './customer/get-tickets/get-tickets.component';
import { GetAssignedTicketsComponent } from './expert/get-assigned-tickets/get-assigned-tickets.component';
import { HomeComponent } from './home/home.component';
import { AlloyComponent } from './alloy/alloy.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppMaterialModule } from './shared/material-module';
import { MainNavComponent } from './shared/main-nav/main-nav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { GetAlloysComponent } from './customer/get-alloys/get-alloys.component';
import { EditAlloysComponent } from './customer/edit-alloys/edit-alloys.component';
import { ForgotusernameComponent } from './user/forgotusername/forgotusername.component';
import { UpdateProfileComponent } from './user-profile/update-profile/update-profile.component';
import { EnterBankingDetailsComponent } from './customer/enter-banking-details/enter-banking-details.component';
import { GetAllUnapprovedCustomersComponent } from './moderator/get-all-unapproved-customers/get-all-unapproved-customers/get-all-unapproved-customers.component';
import { CheckCustomerComponent } from './moderator/check-customer/check-customer/check-customer.component';
import { ReplyToTicketComponent } from './expert/reply-to-ticket/reply-to-ticket.component';
import { CurvePlotterComponent } from './shared/curve-plotter/curve-plotter.component';
import { CurveAnalyzerComponent } from './shared/curve-analyzer/curve-analyzer.component';
import { ViewLatestGraphComponent } from './customer/view-latest-graph/view-latest-graph.component';
import { ViewAllGraphsComponent } from './customer/view-all-graphs/view-all-graphs.component';
import { PaymentComponent } from './payment/payment.component';
import { StandardAlloysComponent } from './customer/standard-alloys/standard-alloys.component';
import { GetCustomersAddCreditComponent } from './moderator/get-customers-add-credit/get-customers-add-credit.component';
import { GetTransactionsComponent } from './customer/get-transactions/get-transactions.component';
import { ViewAllTransactionsComponent } from './shared/view-all-transactions/view-all-transactions.component';
import { ScatterPlotComponent } from './shared/scatter-plot/scatter-plot.component';
import { BlockCopyPasteDirective } from './block-copy-paste.directive';
import { CreateUserComponent } from './moderator/create-user/create-user.component';
import { VerifyConversationComponent } from './moderator/verify-conversation/verify-conversation.component';
import { ChangePasswordFirstloginComponent } from './user/change-password-firstlogin/change-password-firstlogin.component';
import { ManageProfilesComponent } from './moderator/manage-profiles/manage-profiles.component';
import { InvoiceComponent } from './moderator/invoice/invoice.component';
import { ViewTransactionsComponent } from './expert/view-transactions/view-transactions.component';
import { TermsAndConditionsComponent } from './user/terms-and-conditions/terms-and-conditions.component';
import { ReportComponent } from './moderator/report/report.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { TandCLoggedIn } from './customer/TandC-logged-in/TandC-logged-in.component';
import { ChartModule } from 'primeng/chart';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    AppComponent,
    UserComponent,
    SignInComponent,
    UserProfileComponent,
    LandComponent,
    PwdChangeComponent,
    SubscriptionComponent,
    ForgotpwdComponent,
    ResetPwdComponent,
    RaiseTicketComponent,
    AssignExpertComponent,
    GetTicketsComponent,
    GetAssignedTicketsComponent,
    HomeComponent,
    AlloyComponent,
    MainNavComponent,
    GetAlloysComponent,
    EditAlloysComponent,
    ForgotusernameComponent,
    UpdateProfileComponent,
    EnterBankingDetailsComponent,
    GetAllUnapprovedCustomersComponent,
    CheckCustomerComponent,
    ReplyToTicketComponent,
    CurvePlotterComponent,
    CurveAnalyzerComponent,
    ViewLatestGraphComponent,
    ViewAllGraphsComponent,
    PaymentComponent,
    StandardAlloysComponent,
    GetCustomersAddCreditComponent,
    GetTransactionsComponent,
    ViewAllTransactionsComponent,
    ScatterPlotComponent,
    BlockCopyPasteDirective,
    CreateUserComponent,
    VerifyConversationComponent,
    ChangePasswordFirstloginComponent,
    ManageProfilesComponent,
    InvoiceComponent,
    ViewTransactionsComponent,
    TermsAndConditionsComponent,
    TandCLoggedIn,
    ReportComponent,
    AboutComponent,
    ContactComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppMaterialModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    GoogleChartsModule,
    NgbModule,
    NgChartsModule.forRoot(),
    ChartModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
  AuthGuard,
  DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
